/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Variable personnalisee pour le template email
 * @export
 * @interface CustomVariableDto
 */
export interface CustomVariableDto {
    /**
     * Nom de la variable (ex - custom_text)
     * @type {string}
     * @memberof CustomVariableDto
     */
    name: string;
    /**
     * Valeur de la variable
     * @type {string}
     * @memberof CustomVariableDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the CustomVariableDto interface.
 */
export function instanceOfCustomVariableDto(value: object): value is CustomVariableDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CustomVariableDtoFromJSON(json: any): CustomVariableDto {
    return CustomVariableDtoFromJSONTyped(json, false);
}

export function CustomVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function CustomVariableDtoToJSON(json: any): CustomVariableDto {
    return CustomVariableDtoToJSONTyped(json, false);
}

export function CustomVariableDtoToJSONTyped(value?: CustomVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

